<template>
  <div class="auditoria-dashboard">
    <div class="card">
      <div class="card-body">
        <h2 class="title">
          <i class="fas fa-shield-alt"></i>
          Auditoria
        </h2>
        <p class="subtitle">
          Utilize o menu para consultar dados e exportar relatórios em CSV (compatível com Excel).
        </p>
        <div class="tips">
          <div class="tip">
            <i class="fas fa-eye"></i>
            <span>Somente leitura</span>
          </div>
          <div class="tip">
            <i class="fas fa-trash-alt"></i>
            <span>Inclui registros excluídos (quando aplicável)</span>
          </div>
          <div class="tip">
            <i class="fas fa-download"></i>
            <span>Exportação rápida</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuditoriaDashboard'
}
</script>

<style lang="scss" scoped>
.auditoria-dashboard {
  .card {
    border-radius: 14px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  }
  .title {
    margin: 0 0 10px;
    font-size: 22px;
    font-weight: 800;
    color: #2c3e50;
    display: flex;
    align-items: center;
    gap: 10px;
    i {
      color: #4f46e5;
    }
  }
  .subtitle {
    margin: 0 0 16px;
    color: #6c757d;
  }
  .tips {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 12px;
  }
  .tip {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 14px 16px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: #495057;
    i {
      color: #7c3aed;
    }
  }
}
</style>

